exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#rank_comparison_table .rank_table_holder[data-v-40edc361] {\n  text-align: center;\n  overflow: auto;\n}\n#rank_comparison_table table tr[data-v-40edc361] {\n  height: 45px;\n  border-bottom: 1px solid rgba(112, 112, 112, 0.2117647059);\n}\n#rank_comparison_table table thead tr[data-v-40edc361] {\n  border-color: rgba(112, 112, 112, 0.8);\n}\n#rank_comparison_table table thead th[data-v-40edc361] {\n  padding: 0 10px;\n  white-space: nowrap;\n}", ""]);

// exports
